<template>
	<div id="step6" class="sscw-container sscw-flex-column sscw-step step-5">
		<h2 id="top" class="sscw-step-title">
			{{ wizardContent.step6_header ? wizardContent.step6_header : "step6_header" }}
		</h2>
		<h3 class="step-description">
			{{ wizardContent.step6_Description ? wizardContent.step6_Description : "step6_Description" }}
		</h3>
		<div class="sscw-step-image-group">
			<div class="sscw-mobile-hidden desktop-icon">
				<img :src="theme.selfInformationIcon" width="42px" alt="icon" />
			</div>
			<div class="sscw-step-input-group">
				<div class="mobile-img sscw-desktop-hidden">
					<img :src="theme.selfInformationIcon" width="42px" alt="icon" />
				</div>

				<div class="w-full">
					<div class="desktop-row">
						<div class="sscw-container">
							<div class="">
								<div class="sscw-step6-label">
									<div>
										{{
											wizardContent.step6_salutation_label
												? wizardContent.step6_salutation_label
												: "step6_salutation_label"
										}}
									</div>
								</div>
								<div
									class="sscw-step-input-box sscw-mb-10"
									:class="{
										'has-error': salutationInvalid,
									}"
								>
									<v-select
										@blur="validateStep5"
										@search:blur="validateStep5"
										:options="['Herr', 'Frau']"
										:placeholder="
											wizardContent.step6_salutation_placeholder
												? wizardContent.step6_salutation_placeholder
												: 'step6_salutation_placeholder'
										"
										class="sscw-input"
										v-model="salutation"
										:searchable="false"
									>
									</v-select>
								</div>
							</div>
						</div>

						<div class="sscw-container">
							<div class="">
								<div class="sscw-step6-label">
									<div>
										{{
											wizardContent.step6_name_label
												? wizardContent.step6_name_label
												: "step6_name_label"
										}}
									</div>
								</div>
								<div class="sscw-step-input-box sscw-mb-10" :class="{ 'has-error': nameInvalid }">
									<input
										type="text"
										class="sscw-input"
										name="name"
										id="sscw-name"
										@input="validateStep5"
										:placeholder="
											wizardContent.step6_name_placeholder
												? wizardContent.step6_name_placeholder
												: 'step6_name_placeholder'
										"
										v-model="name"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="sscw-step-image-group">
			<div class="sscw-mobile-hidden desktop-icon">
				<img :src="theme.contactIcon" width="42px" alt="icon" />
			</div>
			<div class="sscw-step-input-group">
				<div class="mobile-img sscw-desktop-hidden">
					<img :src="theme.contactIcon" width="42px" alt="icon" />
				</div>

				<div class="w-full">
					<div class="sscw-container">
						<div class="">
							<div class="sscw-step6-label">
								<div>
									{{
										wizardContent.step6_phone_label_beforeBold
											? wizardContent.step6_phone_label_beforeBold
											: "step6_phone_label_beforeBold"
									}}
									<strong>
										{{
											wizardContent.step6_phone_label_bold
												? wizardContent.step6_phone_label_bold
												: "step6_phone_label_bold"
										}}
									</strong>
									{{
										wizardContent.step6_phone_label_afterBold
											? wizardContent.step6_phone_label_afterBold
											: "step6_phone_label_afterBold"
									}}
								</div>
							</div>
							<div
								class="sscw-step-input-box sscw-mb-10"
								:class="{
									'has-error': phoneNumberInvalid,
								}"
							>
								<input
									@input="validateStep5"
									type="tel"
									class="sscw-input"
									name="phoneNumber"
									id="sscw-phone-number"
									v-model="phoneNumber"
									:placeholder="
										wizardContent.step6_phone_placeholder
											? wizardContent.step6_phone_placeholder
											: 'step6_phone_placeholder'
									"
								/>
							</div>
						</div>
					</div>
					<div class="sscw-container">
						<div class="">
							<div class="sscw-step6-label">
								<div>
									{{
										wizardContent.step6_email_label
											? wizardContent.step6_email_label
											: "step6_email_label"
									}}
								</div>
							</div>
							<div class="sscw-step-input-box sscw-mb-10" :class="{ 'has-error': emailInvalid }">
								<input
									@input="validateStep5"
									type="email"
									class="sscw-input"
									name="email"
									id="sscw-email"
									v-model="email"
									:placeholder="
										wizardContent.step6_email_placeholder
											? wizardContent.step6_email_placeholder
											: 'step6_email_placeholder'
									"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="sscw-step-image-group">
			<div class="sscw-mobile-hidden desktop-icon">
				<img :src="theme.dsgvoIcon" width="42px" alt="icon" />
			</div>
			<div class="sscw-step-input-group">
				<div class="mobile-img sscw-desktop-hidden">
					<img :src="theme.dsgvoIcon" width="42px" alt="icon" />
				</div>

				<div class="w-full">
					<div class="sscw-container">
						<div class="">
							<div class="sscw-step-input-label">Datenschutzerklärung</div>
							<div class="dsgvo-row">
								<label :class="{ 'dsgvo-label': true }" for="dsgvo">
									Wir werden Ihre Angaben nur zum Zwecke der Vertragsanbahnung und Beratung im Vorfeld
									verwenden. Näheres zu unserer Datenverarbeitung finden Sie unter:
									<a class="dsgvo-link" target="_blank" href="/datenschutz/">Datenschutzhinweise</a>
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import "vue-select/dist/vue-select.css";
import VueSelect from "vue-select";
import getTheme from "@/utils/theme";
import wizardContent from "@/utils/extnWizardContent";

// Required fields constants
const IS_PHONENUMBER_REQUIRED = true;
const IS_SALUTATION_REQUIRED = true;
const IS_NAME_REQUIRED = true;
const IS_ADDRESS_REQUIRED = true;
const IS_ZIPCODE_REQUIRED = true;
const IS_STATE_REQUIRED = true;
const IS_EMAIL_REQUIRED = true;
const IS_DSGVO_REQUIRED = false;
export default {
	name: "ClickWizardStep1",
	components: {
		"v-select": VueSelect,
	},
	data() {
		return {
			theme: getTheme(),
			wizardContent: wizardContent(),
			salutationInvalid: false,
			nameInvalid: false,
			phoneNumberInvalid: false,
			emailInvalid: false,
			addressInvalid: false,
			zipCodeInvalid: false,
			stateInvalid: false,
			dsgvo: false,
			dsgvoInvalid: false,
		};
	},
	computed: {
		salutation: {
			get() {
				return this.$store.wizardState.salutation;
			},
			set(value) {
				this.$store.wizardState.salutation = value;
			},
		},
		name: {
			get() {
				return this.$store.wizardState.name;
			},
			set(value) {
				this.$store.wizardState.name = value;
			},
		},
		phoneNumber: {
			get() {
				return this.$store.wizardState.phone;
			},
			set(value) {
				this.$store.wizardState.phone = value;
			},
		},
		email: {
			get() {
				return this.$store.wizardState.email;
			},
			set(value) {
				this.$store.wizardState.email = value;
			},
		},
		address: {
			get() {
				return this.$store.wizardState.address;
			},
			set(value) {
				this.$store.wizardState.address = value;
			},
		},
		zipCode: {
			get() {
				return this.$store.wizardState.zipCode;
			},
			set(value) {
				this.$store.wizardState.zipCode = value;
			},
		},
		state: {
			get() {
				return this.$store.wizardState.state;
			},
			set(value) {
				this.$store.wizardState.state = value;
			},
		},
		moreInfo: {
			get() {
				return this.$store.wizardState.moreInfo;
			},
			set(value) {
				this.$store.wizardState.moreInfo = value;
			},
		},
		pdfNotification: {
			get() {
				return this.$store.wizardState.pdfNotification;
			},
			set(value) {
				this.$store.wizardState.pdfNotification = value;
			},
		},
		digitalNotification: {
			get() {
				return this.$store.wizardState.digitalNotification;
			},
			set(value) {
				this.$store.wizardState.digitalNotification = value;
			},
		},
		requestOffer: {
			get() {
				return this.$store.wizardState.requestOffer;
			},
			set(value) {
				this.$store.wizardState.requestOffer = value;
			},
		},
	},
	mounted() {
		this.emitUpdate();
		this.$store.isCurrentStepValid = true;
		if (!this.checkValidation()) {
			this.$store.isCurrentStepValid = false;
		}
	
		this.$nextTick(() => {
			document
				.querySelector("#shortcode-2-977 > ss-lebenswert-wizard-extn")
				?.shadowRoot.querySelector("#top")
				?.scrollIntoView();
			// document.querySelector("#div_block-62-1005")?.scrollIntoView();

			// const bodyEl = document.getElementsByTagName('body')[0]
			// bodyEl.scrollIntoView();

			// document.getElementsByTagName('body')[0].scrollTop = 1;

			window.scrollTo(0, -150);
		});
	},
	methods: {
		emitUpdate() {
			this.$emit("updated", {
				salutation: this.salutation,
				name: this.name,
				phoneNumber: this.phoneNumber,
				email: this.email,
				address: this.address,
				zipCode: this.zipCode,
				state: this.state,
				moreInfo: this.moreInfo,
				pdfNotification: this.pdfNotification,
				digitalNotification: this.digitalNotification,
			});
		},
		checkField(fields, flag, condition) {
			if (flag && condition) {
				fields.push(false);
			}
		},
		onInputChange(){
			this.validateStep5()
		},
		checkValidation() {
			const invalidFields = [];
			this.checkField(invalidFields, IS_SALUTATION_REQUIRED, !this.salutation);
			this.checkField(invalidFields, IS_NAME_REQUIRED, !this.name);
			this.checkField(invalidFields, IS_DSGVO_REQUIRED, !this.dsgvo);
			if (this.requestOffer) {
				this.checkField(invalidFields, IS_ADDRESS_REQUIRED, !this.address);
				this.checkField(invalidFields, IS_ZIPCODE_REQUIRED, !this.zipCode);
				this.checkField(invalidFields, IS_STATE_REQUIRED, !this.state);
			}

			this.checkField(
				invalidFields,
				IS_PHONENUMBER_REQUIRED,
				!this.phoneNumber // && !this.phoneNumber?.startsWith("00")
			);
			this.checkField(invalidFields, IS_EMAIL_REQUIRED, !this.email);
			if (invalidFields.length === 0) {
				return true;
			}
			return false
		},
		validateForm() {
			const invalidFields = [];

			if (IS_SALUTATION_REQUIRED) {
				this.salutationInvalid = !this.salutation;
				invalidFields.push(this.salutationInvalid);
			}

			if (IS_NAME_REQUIRED) {
				this.nameInvalid = !this.name;
				invalidFields.push(this.nameInvalid);
			}
			if (this.requestOffer) {
				if (IS_ADDRESS_REQUIRED) {
					this.addressInvalid = !this.address;
					invalidFields.push(this.addressInvalid);
				}

				if (IS_ZIPCODE_REQUIRED) {
					this.zipCodeInvalid = !this.zipCode;
					invalidFields.push(this.zipCodeInvalid);
				}

				if (IS_STATE_REQUIRED) {
					this.stateInvalid = !this.state;
					invalidFields.push(this.stateInvalid);
				}
			}

			if (IS_PHONENUMBER_REQUIRED) {
				this.phoneNumberInvalid = !this.phoneNumber //?.startsWith("00");
				invalidFields.push(this.phoneNumberInvalid);
			}

			if (IS_EMAIL_REQUIRED) {
				this.emailInvalid = !this.email;
				invalidFields.push(this.emailInvalid);
			}
			if (IS_DSGVO_REQUIRED) {
				this.dsgvoInvalid = !this.dsgvo;
				invalidFields.push(!this.dsgvo);
			}
			const isValid = (isInvalid) => !isInvalid;
			return invalidFields.every(isValid);
		},
		validateStep5() {
			this.$emit("onValidation", this.validateForm());
		},
	},
};
</script>

<style scoped>
.jump-to-top {
	visibility: hidden;
}

.sscw-step-textarea-box {
	margin-top: 10px;
}

.sscw-step-input-group {
	display: flex;
	flex-direction: row;
}

.w-full {
	width: 100%;
}

.sscw-step-input {
	width: 100%;
}

.sscw-step-input-content {
	display: flex;
	flex-direction: column;
	gap: unset;
}

.mobile-img {
	align-self: flex-start;
	margin-left: 14px;
}

.dsgvo-row {
	margin-top: 14px;
}

.sscw-step6-label {
	font-family: Inter;
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0em;
	text-align: left;
}

.dsgvo-label {
	font-family: Inter;
	font-size: 14px;
	font-weight: 400;
	line-height: 18px;
	letter-spacing: 0em;
	text-align: left;
}

.dsgvo-error {
	color: red;
}

.sscw-step-image-group {
	margin-bottom: 20px;
	display: flex;
	gap: 34px;
	align-items: center;
}

.image-div {
	display: none;
}

.checkbox-desktop-row {
	display: flex;
	gap: 8px;
	flex-direction: column;
	margin-top: 13px;
}

.dsgvo-link {
	text-decoration: none;
}

.checkbox-group {
	display: flex;
	gap: 10px;
	align-items: center;
}

.checkbox-label {
	font-family: Inter;
	font-size: 16px;
	font-weight: 400;
	line-height: 21px;
	letter-spacing: 0em;
	text-align: left;
	display: block;
}

.checkbox-input {
	accent-color: #112c42;
	width: 18px;
	height: 18px;
	display: block;
	margin: 0;
	padding: 0;
}

.flex-row {
	display: flex;
}

@media (min-width: 1190px) {
	.desktop-row {
		display: flex;
		gap: 12px;
		padding: 0 32px;
	}

	.pos-relative {
		position: relative;
	}

	.image-div {
		position: absolute;
		right: -34px;
		top: -16px;
		display: block;
	}

	.checkbox-desktop-row {
		flex-direction: row;
		gap: 140px;
	}

	.sscw-step-input-group {
		width: 686px;
	}

	.sscw-step6-label {
		font-size: 18px;
		line-height: 20px;
	}
}
</style>
